<template>
  <detail-layout-two-columns :toEdge="false">
    <template slot="LeftCol">
      <base-header
        style="padding-left: 0px"
        icon="user"
        :content="header"
      />
        <div class="form-wrapper">
          <el-form
            :model="form"
            ref="ruleForm"
          >
            <div  class="hideHScroll">
              <div class="mb-4 flex" v-if="form.NeoAMano">
                <base-ro-input :label="$t('app.neo_manual')"/>
              </div>
              <div class="mb-4 flex" v-if="form.DescargadaAutomaticamente">
                <base-ro-input :label="$t('app.neo_descarga_automatica')"/>
              </div>

              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="role === 'SuperAdministrador' && form.Distribuidor">
                  <base-ro-input :label="$t('distributors.distributor')" :data="form.Distribuidor"/>
                </div>
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
                  <base-ro-input :label="$t('app.client')" :data="form.Empresa"/>
                </div>
              </div>

              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('app.CIFTitular')" :data="form.CIFTitular"/>
                </div>
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('companies.companyName')" :data="form.NombreEmpresa"/>
                </div>
              </div>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('notificationFilter.agency')" :data="form.Organismo"/>
                  </div>
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('notificationFilter.location')" :data="form.Sede"/>
                  </div>
              </div>
              <div class="lg:mb-4">
                <base-ro-input :label="$t('notificationFilter.subject')" :data="form.Asunto"/>
              </div>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('notificationFilter.disposition_date')" :data="form.FechaDisposicion"/>
                  </div>
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('app.date_download')" :data="form.FechaDescarga"/>
                  </div>
              </div>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('app.TicketID')" :data="form.TicketID"/>
                  </div>
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('notificationFilter.status')" :data="form.Estado"/>
                  </div>
              </div>
              <div class="lg:mb-4">
                <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.end_date')}}
                  <el-form-item prop="fechaFinTramite">
                    <el-date-picker
                      :clearable="false"
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.fechaFinTramite"
                      type="date"
                      format="dd-MM-yyyy"
                      placeholder="dd-mm-aaaa"
                      :picker-options="dateRangeOptions"
                      disabled
                      >
                    </el-date-picker>
                  </el-form-item>
                </label>
              </div>
              <div class="mt-8 lg:mb-4">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Metadatos adicionales</h2>
                <base-accessible-table
                  ref="metadatos"
                  :rows="form.Metadatos"
                  :columns="metadatosColumns"
                  rowKey="Campo"
                  :theadClass="form.Metadatos && form.Metadatos.length > 0 ? '' : 'sr-only'"
                >
                  <template #cell-Campo="{ row }">
                    <span :title="row.Campo">{{ row.Campo }}</span>
                  </template>
                  <template #cell-Valor="{ row }">
                    <span :title="row.Valor">{{ row.Valor }}</span>
                  </template>
                </base-accessible-table>
              </div>
              <table-element-adjuntos
                :Adjuntos="form.Adjuntos"
                @showAdjunto="showAdjunto"
                @downloadAdjunto="downloadAdjunto"
                />
              <table-element-doc-relacionados
                :DocumentosRelacionados="form.DocumentosRelacionados"
                :hasModulePresentacionesAEAT="hasModulePresentacionesAEAT"
                :isFromAEAT="isFromAEAT"
                @showAdjunto="showAdjunto"
                @downloadAdjunto="downloadAdjunto"
                />
              <!-- <div class="w-full m-2 float-right">
              </div> -->
              <div class="pb-2" v-if="form.MotivoRechazo">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.MotivoRechazo')}}
                    <el-form-item prop="MotivoRechazo">
                      <el-input
                        disabled
                        type="textarea"
                        :rows="3"
                        clearable
                        class="w-full"
                        v-model="form.MotivoRechazo"
                        maxlength="1000"
                      />
                    </el-form-item>
                  </label>
              </div>
              <div class="pb-4">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.full_text')}}
                    <el-form-item prop="full_text">
                      <el-input
                        type="textarea"
                        :rows="3"
                        clearable
                        class="w-full"
                        v-model="form.full_text"
                        maxlength="1000"
                        disabled
                      />
                    </el-form-item>
                  </label>
              </div>
              
              <div class="mb-8" v-if="form.UsuarioResponsable">
                <base-ro-input :label="$t('app.user_responsable')" :data="form.UsuarioResponsable.Usuario"/>
              </div>

            </div>
          </el-form>
        </div>
    </template>
    <template slot="RightCol">
      <div 
        ref="pdfContainer"
        :class="{ 'h-screen': showPdf }" 
        class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full"
        >
          <PDFViewerApp
            v-show="showPdf"
            :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler"
            :pdf="url"
            :container-width="pdfContainerWidth"/>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
           <base-button-responsive
            v-if="enableActions"
            mode="primary"
            :text="$t('trash.delete')"
            icon="trash"
            @click="deleteNotification()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="enableActions"
            mode="primary"
            :text="$t('trash.restore')"
            icon="restore"
            @click="restoreNotification()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        title="Borrar notificación"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
        </BaseElDialog>
    </template>
  </detail-layout-two-columns>
</template>

<script>
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import { getNotification } from '@/services/notifications/getNotification'
import { descargarAdjunto } from '@/services/notifications/descargarAdjunto'
import { descargarPdf } from '@/services/notifications/descargarPdf'
import moment from 'moment'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { deleteTrashNEO } from '@/services/trash/deleteTrashNEO'
import { restoreTrashNEO } from '@/services/trash/restoreTrashNEO'
import { TIPOS_ESTADOS_DESCARGA_DOWNLOADED } from '@/config/tipos-estados-descarga-downloaded'
import { TIPOS_DOCUMENTOS_AEAT } from '@/config/tipos-documentos-aeat'

import TableElementDocRelacionados from '@/components/tables/TableElementDocRelacionados.vue'
import TableElementAdjuntos from '@/components/tables/TableElementAdjuntos.vue'

import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

export default {
  name: 'detalle-papelera-notificacion',
  components: {
    DetailLayoutTwoColumns,
    PDFViewerApp,
    BaseElDialog,
    TableElementDocRelacionados,
    TableElementAdjuntos,
    BaseAccessibleTable,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      showNewDocument: false,
      showNewMetadato: false,
      showPdf: false,
      pdfContainerWidth: 0,
      pdfContainerResizeObserver: null,
      pdfContainerResizeFallbackAttached: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: 'DETALLE DE NOTIF. BORRADA',
        icon: 'notification',
        breadcrumb: {},
        nav: [],
        url: 'trash/notifications'
      },
      estadosDescargaDesconocido: TIPOS_ESTADOS_DESCARGA_DOWNLOADED,
      tiposDocumentosAeat: TIPOS_DOCUMENTOS_AEAT,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {
        Asunto: '',
        Adjuntos: [],
        DocumentosRelacionados: [],
        Empresa: '',
        Distribuidor: '',
        IdEstado: null,
        Estado: '',
        FechaDisposicion: '',
        IDInterno: 0,
        Organismo: '',
        Sede: '',
        idSede: -1,
        full_text: '',
        TicketID: '',
        FechaDescarga: '',
        CIFTitular: '',
        NombreEmpresa: '',
        fechaFinTramite: '',
        Metadatos: [],
        enlaceDescarga: '',
        EsPropietario: false,
        NeoAMano: false,
        DescargadaAutomaticamente: false,
        MotivoRechazo: '',
        UsuarioResponsable: null,
      },
      rules: {
        Empresa: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        location: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      },
      url: '',
      documentError: undefined,
      enableUploader: false,
      lastAdjuntoVisible: null,
      lastRelacionadoVisible: null,
      notificationType: null,
      notificationActions: null,
      showModal: false,
      processMessage: '¿Estás seguro que deseas borrar permanentemente la notificación?',
      selectedAction: null,
      actualFilterContent: null,
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    showPdf (value) {
      if (value) {
        this.$nextTick(() => {
          this.updatePdfContainerWidth()
        })
      }
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.setupPdfContainerObserver()
    })
  },
  beforeDestroy () {
    this.teardownPdfContainerObserver()
  },
  computed: {
    hasModulePresentacionesAEAT () {
      return this.$store.getters['auth/hasModulePresentacionesAEAT']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isFromAEAT () {
      return this.form.idSede === 203
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    notificationId: function () {
      return parseInt(this.$route.params.id)
    },
    enableActions () {
      return this.form.EsPropietario
    },
    metadatosColumns () {
      return [
        { key: 'Campo', label: 'Campo', align: 'left', minWidth: '200px' },
        { key: 'Valor', label: 'Valor', align: 'left', minWidth: '200px' },
      ]
    },
  },
  created: async function () {
    const notificationId = this.notificationId

    this.filterByParamsData()

    await this.downloadNotificationData(notificationId)

    const breadcrumbs = []
    breadcrumbs.push({
      path: 'trash/notifications',
      name: this.$i18n.t('app.trash')
    })
   
    breadcrumbs.push({ path: 'trash/notifications', name: this.$i18n.t('trash.notifications_short') })
    breadcrumbs.push({ path: '', name: this.truncate(this.form.Asunto, 30, false) })
    this.$store.commit('app/setheaderBreadCrumb', this.form.Asunto)
    this.header.breadcrumb = breadcrumbs

    if (this.form.Adjuntos !== undefined && this.form.Adjuntos.length > 0) {
      if (this.form.Adjuntos[0].Extension === 'pdf') {
        this.showAdjunto(this.form.Adjuntos[0])
      }
    } else if (this.form.DocumentosRelacionados !== undefined && this.form.DocumentosRelacionados.length > 0) {
      if (this.form.DocumentosRelacionados[0].Extension === 'pdf') {
        this.showAdjunto(this.form.DocumentosRelacionados[0])
      }
    }
  },
  methods: {
    updatePdfContainerWidth () {
      try {
        if (!this.$refs.pdfContainer) return
        const { width } = this.$refs.pdfContainer.getBoundingClientRect()
        this.pdfContainerWidth = Math.round(width)
      } catch (error) {
        console.error('Error al actualizar el ancho del contenedor PDF:', error)
      }
    },
    setupPdfContainerObserver () {
      try {
        if (!this.$refs.pdfContainer) return
        this.updatePdfContainerWidth()
        if (typeof ResizeObserver !== 'undefined') {
          if (this.pdfContainerResizeObserver) return
          this.pdfContainerResizeObserver = new ResizeObserver(entries => {
            if (!entries || entries.length === 0) return
            const { width } = entries[0].contentRect
            this.pdfContainerWidth = Math.round(width)
          })
          this.pdfContainerResizeObserver.observe(this.$refs.pdfContainer)
        } else if (!this.pdfContainerResizeFallbackAttached) {
          window.addEventListener('resize', this.updatePdfContainerWidth)
          this.pdfContainerResizeFallbackAttached = true
        }
      } catch (error) {
        console.error('setupPdfContainerObserver:', error)
      }
    },
    teardownPdfContainerObserver () {
      try {
        if (this.pdfContainerResizeObserver && this.$refs.pdfContainer) {
          this.pdfContainerResizeObserver.unobserve(this.$refs.pdfContainer)
          this.pdfContainerResizeObserver.disconnect()
          this.pdfContainerResizeObserver = null
        }
        if (this.pdfContainerResizeFallbackAttached) {
          window.removeEventListener('resize', this.updatePdfContainerWidth)
          this.pdfContainerResizeFallbackAttached = false
        }
      } catch (error) {
        console.error('teardownPdfContainerObserver:', error)
      }
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    filterByParamsData () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'contenido') {
            this.actualFilterContent = filter.data
          } 
        })
      }
    },
    deleteNotification () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsNEOs: []
        }
        payload.idsNEOs.push(this.form.IDInterno)
        const response = await deleteTrashNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreNotification: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsNEOs: []
        }
        payload.idsNEOs.push(this.form.IDInterno)
        const response = await restoreTrashNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    goBack: function () {
      this.$router.push({ name: 'trash/notifications' })
    },
    // eslint-disable-next-line camelcase
    watchFormHandler: function ({ fechaFinTramite }) {
      // eslint-disable-next-line camelcase
      if (fechaFinTramite !== undefined && moment(fechaFinTramite).isValid()) {
        this.form.fechaFinTramite = moment(fechaFinTramite).format('YYYY-MM-DD')
      } else {
        this.form.fechaFinTramite = ''
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    downloadNotificationData: async function (notificationId) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idNEO: notificationId,
          borrados: true,
        }
        const notification = await getNotification(params)
        if (notification.blnError) {
          this.doFeedback(notification.msgError + ' [Código de error: ' + notification.codError + ']')
        }
        this.setNotification(notification.respuesta)
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    setNotification: function (notification) {
      this.form.Distribuidor = notification.Distribuidor
      this.form.Empresa = notification.Empresa.Empresa
      this.form.Sede = notification.Sede.Sede
      this.form.idSede = notification.Sede.Id
      this.form.Organismo = notification.Organismo
      this.form.IdEstado = notification.Estado.Id
      this.form.Estado = notification.Estado.Estado
      this.form.Asunto = notification.Asunto
      this.form.IDInterno = notification.IDInterno
      this.form.FechaDisposicion = moment(notification.FechaDisposicion).format('DD-MM-YYYY HH:mm')
      this.form.full_text = notification.Comentarios
      this.form.MotivoRechazo = notification.MotivoRechazo
      this.form.TicketID = notification.TicketID
      // Formato para fechas dependiendo del tipo de estado
      const yearFechaDescarga = new Date(notification.yearFechaDescarga).getFullYear()
      this.form.FechaDescarga = yearFechaDescarga >= 2000 ? moment(notification.FechaDescarga).format('DD-MM-YYYY HH:mm') : ' - '
      if (this.form.FechaDescarga === ' - ' && this.estadosDescargaDesconocido.includes(this.form.IdEstado)) this.form.FechaDescarga = 'Desconocido'
      this.form.CIFTitular = notification.CIFTitular
      this.form.NombreEmpresa = notification.NombreCIF
      this.form.fechaFinTramite = notification.FechaFinTramite
      this.form.enlaceDescarga = notification.EnlaceDescarga
      this.form.NeoAMano = notification.NeoAMano
      this.form.DescargadaAutomaticamente = notification.DescargadaAutomaticamente
      this.form.EsPropietario = notification.EsPropietario
      this.form.UsuarioResponsable = notification.UsuarioResponsable ? notification.UsuarioResponsable : null

      const adjuntos = notification.Adjuntos
      adjuntos.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.form.Adjuntos = adjuntos

      const documentosRelacionados = notification.DocumentosRelacionados
      documentosRelacionados.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.form.DocumentosRelacionados = documentosRelacionados

      if (notification.MetadatosAdicionales !== undefined) {
        this.form.Metadatos = notification.MetadatosAdicionales
          .filter((x) => x.Valor !== '' && x.Campo !== 'XmlNotificacion')
          .sort((a, b) => {
            if (a.Campo < b.Campo) return -1
            if (a.Campo > b.Campo) return 1
            return 0
          })
      }
    },
    showAdjunto: async function (row) {
      this.form.Adjuntos.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.form.DocumentosRelacionados.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      if (this.showPdf === true && this.lastAdjuntoVisible !== null && this.lastAdjuntoVisible.idAdjunto === row.idAdjunto) {
        this.showPdf = false
      } else {
        if (row.Extension.trim() === 'pdf' || row.Extension.trim() === 'PDF') {
          await this.showPDFHandler(row.idAdjunto)
          this.showPdf = true
          row.visible = this.showPdf
          row.icon = 'eyeslash'
          this.lastAdjuntoVisible = row
        } else {
          this.showPdf = false
          await this.downloadAdjunto(row)
        }
      }
    },
    onDocumentErrored: function (e) {
      this.documentError = e.text
    },
    downloadAdjunto: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idAdjunto: row.idAdjunto
        }
        const response = await descargarAdjunto(row.idAdjunto, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        // const headerVal = response.headers['content-disposition']
        let filename = row.Nombre + '.' + row.Extension
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    showPDFHandler: async function (idAdjunto) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idAdjunto: idAdjunto,
          automatico: true,
        }

        const adjunto = await descargarPdf(idAdjunto, params)
        const blob = new Blob([adjunto], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        this.url = url
        // window.open(url)
      } catch (error) {
        this.doFeedback('Error al descargar el adjunto')
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substr(0, n - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    showActionModal: function (action) {
      this.showModal = !this.showModal
      this.selectedAction = action
    },
  }

}
</script>

<style scoped>
.full-screen-pdf{
  position:fixed;
  top:0;
  left:0;
  z-index:99999;
}
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="scss" >
.hideHeader {
  display: none
}
.showHeader {
  display: block
}
.hideHScroll {
  overflow-x: hidden;
}
</style>
